import { applyIf } from "utils";

// Default base URL for same-origin requests. Leave empty so services
// must pass `options.baseUrl` to target other hosts.
const API_URL = "";

type Options = {
  omitUrlPrefix?: boolean;
  headers?: Record<string, string>;
  baseUrl?: string;
};

type Request = {
  url: string;
  options?: Options;
};

type RequestWithBody = {
  data: Record<string, any>;
} & Request;

const getFullUrl = (url: string, baseUrl?: string) =>
  `${baseUrl || API_URL}${url}`;

const getUrl = (url: string, omitUrlPrefix?: boolean, baseUrl?: string) =>
  applyIf(!omitUrlPrefix, (u: string) => getFullUrl(u, baseUrl))(url);

export const post = ({
  url,
  data,
  options: { omitUrlPrefix, headers = {}, baseUrl } = {},
}: RequestWithBody) =>
  fetch(getUrl(url, omitUrlPrefix, baseUrl), {
    method: "POST",
    credentials: "include",
    redirect: "follow",
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    body: JSON.stringify(data),
  });

export const put = ({
  url,
  data,
  options: { omitUrlPrefix, headers = {}, baseUrl } = {},
}: RequestWithBody) =>
  fetch(getUrl(url, omitUrlPrefix, baseUrl), {
    method: "PUT",
    credentials: "include",
    redirect: "follow",
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    body: JSON.stringify(data),
  });

export const get = ({
  url,
  options: { omitUrlPrefix, headers = {}, baseUrl } = {},
}: Request) =>
  fetch(getUrl(url, omitUrlPrefix, baseUrl), {
    method: "GET",
    credentials: "include",
    headers: { "Content-Type": "application/json", ...headers },
  });
